import { Pipe, PipeTransform } from "@angular/core";
import { ExperienceLevelType } from "../interfaces";

@Pipe({
    name: "experienceIcon",
    pure: true,
})
export class ExperienceIconPipe implements PipeTransform {
    transform(level: ExperienceLevelType): string {
        return level === ExperienceLevelType.ADVANCED ? "donut_small" : "donut_large";
    }
}
